import Immutable from 'seamless-immutable';
import _ from 'lodash';

/**
 * SmartUrl
 * @typedef {object} Smart URL
 * @property {string} id - the unit id
 * @property {string} shortCode
 * @property {string} url
 * @property {string} customUrl - URL for the channels with a custom domain name
 */

const _keys = ['id', 'shortCode', 'url', 'customUrl'];

function create(smartUrl = {}) {
  return Immutable(smartUrl, { prototype: model });
}

function deserialize(smartUrl) {
  const result = _.pick(smartUrl, _keys);
  return create(result);
}

function serialize(smartUrl) {
  const result = smartUrl.asMutable({ deep: true });
  return _.pick(result, _keys);
}

const model = {};

export default {
  create,
  deserialize,
  serialize,
};
